import { onSnapshot } from 'firebase/firestore';
import { action, computed, observable } from 'mobx';
import MobxState from '../../../abstract/MobxState';

class FirebaseRefListener extends MobxState {
  constructor(root, options) {
    super(root);
    this.options_ = options;
    this.root = root.root;
    this.parent = root;
  }

  snapshot = null;

  error = '';

  init() {
    super.init();
    const { ref, snapshot, listenRef = true } = this.options_;
    if (snapshot) {
      this.handleSnapshot(snapshot);
    } else {
      this.ref = ref;
    }
    this.listenRef = listenRef;

    if (this.listenRef) this.listen();
  }

  get isInitialized() {
    return !!(this.snapshotDestroy_ && (this.error || this.snapshot));
  }

  get id() {
    return this.ref?.id;
  }

  listen() {
    this.snapshotDestroy_?.();
    this.snapshotDestroy_ = onSnapshot(
      this.ref,
      (snapshot) => this.handleSnapshot(snapshot),
      (error) => this.handleError(error)
    );
  }

  handleSnapshot(snapshot) {
    this.error = '';
    this.snapshot = snapshot;
    this.ref = snapshot.ref;
  }

  handleError(error) {
    this.error = error.message;
  }
}

FirebaseRefListener.annotations = {
  ...MobxState.annotations,
  snapshot: observable.ref,
  isInitialized: computed,
  error: observable,
  handleSnapshot: action,
  handleError: action,
};

export default FirebaseRefListener;
